import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type MailIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const MailIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: MailIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32.0133 32.0133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0042 13.0054L13.9064 15.4113C15.1941 16.2051 16.8193 16.2051 18.1069 15.4113L22.0092 13.0054"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4.00167"
        y="6.66944"
        width="24.01"
        height="18.6744"
        rx={3}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
